// spell-checker: disable
let config = {
  cloudfrontDomain: "df6uh3geio3c.cloudfront.net",
  version: "1.1.9",
  googleClientId: "169091229006-1587f1684k81ftdsaa1pfa6vm7tg5cgj.apps.googleusercontent.com",
  enableGoogleLogin: true,
  webrtcFilterEnabled: true,
};

const env = import.meta.env.VITE_ENV || import.meta.env.MODE;

if (env === "production") {
  config = {
    ...config,
    apiUrl: "https://api.cavalryhr.com",
    sentryDsn: "https://d462a0b8cc14c54297214bc424e9245e@o4509429929345024.ingest.us.sentry.io/4509429932228608",
  };
} else if (env === "test") {
  config = {
    ...config,
    apiUrl: "https://api-test.cavalryhr.com",
  };
} else {
  // development
  config = {
    ...config,
    apiUrl: "http://localhost:8080",
  };
}

// webrtcfilter=on migration gate. Requires the backend relay (observer + /realtime-relay WS)
// to be live in the target environment. Off by default; enable per-env via VITE_WEBRTC_FILTER=true
// once the relay is confirmed deployed. When off, the interview uses the legacy direct-Azure flow
// (no filter; session.updated and tool calls arrive on the data channel).
// config.webrtcFilterEnabled = import.meta.env.VITE_WEBRTC_FILTER === "true";

export default config;